module.exports = __webpack_public_path__ + "img/user management.7d2ca086.svg";